import React from 'react';
import { IAuditoriaAdiantamentoSociosResultado } from '../interfaces/IAuditoriaAdiantamentoSocios';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaAdiantamentoSociosResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Adiantamentos a Sócios (Caracterização de Remuneração) — não é um tributo, é
// uma auditoria complementar que compara o saldo de Adiantamento a Sócios (Ativo) com o saldo
// líquido de Lucros Acumulados disponível. Excedente sem lastro em lucro caracteriza remuneração
// (pró-labore), sujeita a INSS patronal, IRRF e Multa ECD.
const AuditoriaResumoAdiantamentoSocios: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.adiantamentosSemLastro?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Adiantamentos a Sócios (Caracterização de Remuneração)</h3>
      <p className='text-muted'>
        Auditoria complementar — saldo de Adiantamento a Sócios (Ativo) sem lastro suficiente em Lucros
        Acumulados caracteriza remuneração (pró-labore) disfarçada de Distribuição Disfarçada de Lucros,
        sujeita a INSS patronal (20%), IRRF pela tabela progressiva e Multa ECD potencial (5% limitada
        a 1% da receita bruta do período). Clique para ver a
        análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_ADIANTAMENTO_SOCIOS')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Adiantamentos a Sócios (Caracterização de Remuneração)</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} adiantamento{totalOcorrencias === 1 ? '' : 's'} sem lastro suficiente em lucro no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>INSS patronal 20% + IRRF tabela progressiva + Multa ECD potencial (5% limitada a 1% da receita bruta)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoAdiantamentoSocios;
